import type { MenuItemDetail, ModifierGroup, VariationSelection } from './types'

const slot = (selection: VariationSelection) => selection.slotKey ?? ''
export function availableModifierGroups(item: MenuItemDetail, selections: VariationSelection[]) {
  const has = (id: number | null | undefined, key: string) => !id || id < 0 || selections.some(s =>
    s.variation === id && (slot(s) === key || slot(s) === ''))
  return item.modifierGroups.filter(group => has(group.allowIfVariationId, group.slotKey)).map(group => ({
    ...group, variations: group.variations.filter(v => has(v.allowIfVariationId, group.slotKey)),
  }))
}

/** Resolve from roots, like the server: hidden dependants and unrooted cycles cannot survive an edit. */
export function reachableSelections(item: MenuItemDetail, selections: VariationSelection[]) {
  let reachable: VariationSelection[] = []
  for (;;) {
    const groups = availableModifierGroups(item, reachable)
    const next = selections.filter(s => groups.some(g => g.slotKey === slot(s) && g.variations.some(v => v.id === s.variation)))
    if (next.length === reachable.length) return next
    reachable = next
  }
}

export function toggleModifier(item: MenuItemDetail, selections: VariationSelection[], group: ModifierGroup, variation: number) {
  const inGroup = (s: VariationSelection) => slot(s) === group.slotKey && group.variations.some(v => v.id === s.variation)
  const selected = selections.some(s => inGroup(s) && s.variation === variation)
  const kept = selections.filter(s => !(inGroup(s) && (!group.multipleSelectionPossible || s.variation === variation)))
  if (!selected) {
    const count = kept.filter(inGroup).length
    if (group.maximumVariationCount && count >= group.maximumVariationCount) return selections
    kept.push({ variation, slotKey: group.slotKey, position: group.slotPosition })
  }
  return reachableSelections(item, kept)
}
